module.exports = __webpack_public_path__ + "img/herophone-image.63b4f6b1.png";